import { Button, Checkbox, TableBody, TableHead } from '@mui/material';
import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import React, { useState } from 'react';

import { CustomButton } from '@components/Styles/ButtonStyle';
import CustomCheckBox from '@components/common/Input/CustomCheckBox';
import { CustomStack } from '@components/Styles/CommonStyle';
import api from '@api/axios';

const UserListTable = ({ isCheckboxAllSelect, handleCheckAll, userList, checkedUserList, handleCheckedUserList, handleUserReg, handleIsAdminChange }) => {

  return (
    <React.Fragment>
      <CustomTableContainer>
        <CustomTable>
          <TableHead>
            <CustomTableRow>
              <CustomHeaderCell>
                <CustomCheckBox checked={isCheckboxAllSelect} onChange={handleCheckAll} size="small" />
              </CustomHeaderCell>
              <CustomHeaderCell align="center">사용자명</CustomHeaderCell>
              <CustomHeaderCell align="center">아이디</CustomHeaderCell>
              <CustomHeaderCell align="center">관리자 여부</CustomHeaderCell>
              <CustomHeaderCell align="center">비밀번호</CustomHeaderCell>
              <CustomHeaderCell align="center">상태</CustomHeaderCell>
            </CustomTableRow>
          </TableHead>
          <TableBody>
            {userList.length > 0 ? (
              userList.map((user) => (
                <CustomTableRow hover>
                  <CustomBodyCell align="center">
                    <CustomCheckBox
                      checked={checkedUserList.includes(user.user_id)}
                      onChange={(e) => handleCheckedUserList(e, user.user_id)}
                      size="small"
                    />
                  </CustomBodyCell>
                  <CustomBodyCell align="center">{user.name}</CustomBodyCell>
                  <CustomBodyCell align="center">{user.user_id}</CustomBodyCell>
                  <CustomBodyCell align="center">
                    <Checkbox
                      size="small"
                      fullWidth
                      placeholder="비밀번호 확인(비밀번호 재입력)"
                      checked={user.is_admin === 1 ? true : false}
                      onChange={(event) => handleIsAdminChange(event, user)}
                    />
                  </CustomBodyCell>
                  <CustomBodyCell align="center">
                    <Button variant="text" onClick={() => handleUserReg(user)}>
                      비밀번호 변경
                    </Button>
                  </CustomBodyCell>
                  <CustomBodyCell align="center">
                    <CustomStack justifyContent="center">{user.is_deleted === 0 ? '사용' : '해지'}</CustomStack>
                  </CustomBodyCell>
                </CustomTableRow>
              ))
            ) : (
              <CustomTableRow>
                <CustomBodyCell colSpan={6} align="center">
                  등록된 사용자가 없습니다.
                </CustomBodyCell>
              </CustomTableRow>
            )}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </React.Fragment>
  );
};

export default UserListTable;
